import { createAsyncThunk } from "@reduxjs/toolkit";
import { CreateTimeoffCategoryRequest, IRejectWithValue, PhpResponse, UpdateTimeoffCategoryRequest } from "../../../types";
import { phpClient } from "../../../network";

export const createTimeoffCategory = createAsyncThunk<PhpResponse<any>, CreateTimeoffCategoryRequest, IRejectWithValue>(
    "timeoffcategory/createTimeoffCategory",
    async (data, { rejectWithValue }) => {
        try {
            const response = await phpClient.post<PhpResponse<any>>({
                url: "/timeoff/create_timeoff_category",
                data,
            });
            return response;
        } catch (error: any) {
            return rejectWithValue(error.message || "An error occurred");
        }
    }
);

export const updateTimeoffCategory = createAsyncThunk<PhpResponse<any>, UpdateTimeoffCategoryRequest, IRejectWithValue>(
    "timeoffcategory/updateTimeoffCategory",
    async (data, { rejectWithValue }) => {
        try {
            const { category_code } = data;
            const response = await phpClient.post<PhpResponse<any>>({
                url: `/timeoff/update_timeoff_category/${category_code}`,
                data,
            });

            return response;
        } catch (error: any) {
            return rejectWithValue(error.message || "An error occurred");
        } 
    }  
);